<template>
  <div class="search-jobs">
    <div class="sidebar-full-bg"></div>
    <div class="container">
      <div class="search-block">
        <div class="row">
          <div class="col-lg-10 mx-auto search-header-wrapper">
            <h1 class="text-center h4">Be a Part of Axilweb's Growing Team.</h1>
            <p class="text-center">"Make an impact doing what you love."</p>
            <div class="search-bar">
              <form
                class="job-search-form d-flex flex-wrap justify-content-center"
                @submit.prevent="searchNow"
              >
                <div class="input-wrapper search-input">
                  <label for="search-jobs" class="sr-only"
                    >Search by job title, keyword or phrase....</label
                  >
                  <input
                    id="search-jobs"
                    v-model="search"
                    name="search"
                    type="text"
                    placeholder="Search by job title, keyword or phrase...."
                  />
                  <i
                    class="far fa-times clear-search"
                    v-if="search"
                    @click.prevent="clearSearchBox"
                  ></i>
                </div>
                <div class="btn-wrapper">
                  <button class="primary-btn w-100" type="submit">
                    SEARCH JOB
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div class="search-result-block">
        <div class="row">
          <div
            class="col-lg-3 offset-lg-1 sidebar-job-filter"
            :class="{ 'sidebar-job-filter-active': showSidebarFilter }"
          >
            <div class="filter-block">
              <div class="close-btn-inner d-block d-lg-none mb-5 mt-2">
                <button
                  type="button"
                  class="filter-closebtn btn-link"
                  @click="showSidebarFilter = false"
                >
                  <i class="fal fa-times"></i>Close
                </button>
              </div>
              <div class="filter-block--child">
                <div class="toggleable-child-slots">
                  <h6
                    class="label m-b-0 toggle-thumb"
                    :class="{ 'thumb-visible': showThumb1 }"
                    @click="showThumb1 = !showThumb1"
                  >
                    JOB TYPE
                  </h6>
                  <div class="inner-wrapper" v-show="showThumb1">
                    <div class="job-type">
                      <div class="job-type--radio-values custom-radio">
                        <input
                          @change.prevent="filterJob('job_type')"
                          type="radio"
                          id="job-type--radio-values-all"
                          value
                          v-model="f_job_type"
                          name="job-type--radio-values"
                          checked
                        />
                        <label for="job-type--radio-values-all">All</label>
                      </div>
                      <div
                        v-for="(item, index) in jobTypes"
                        :key="index"
                        class="job-type--radio-values custom-radio"
                        v-if="item.total_job > 0"
                      >
                        <input
                          @change.prevent="filterJob('job_type')"
                          type="radio"
                          :id="'job-type--radio-values-' + index"
                          :value="item.id"
                          v-model="f_job_type"
                          name="job-type--radio-values"
                        />
                        <label :for="'job-type--radio-values-' + index"
                          >{{ item.name }} ({{ item.total_job }})</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="filter-block--child">
                <div class="toggleable-child-slots">
                  <h6
                    class="label m-b-0 toggle-thumb"
                    :class="{ 'thumb-visible': showThumb2 }"
                    @click="showThumb2 = !showThumb2"
                  >
                    DEPARTMENT
                  </h6>
                  <div class="inner-wrapper" v-show="showThumb2">
                    <div class="job-department">
                      <div class="job-department--radio-values custom-radio">
                        <input
                          @change.prevent="filterJob('department')"
                          type="radio"
                          id="job-department--radio-values-all"
                          value
                          v-model="f_department"
                          name="job-department--radio-values"
                          checked
                        />
                        <label for="job-department--radio-values-all"
                          >All</label
                        >
                      </div>
                      <div
                        v-for="(item, index) in departments"
                        :key="index"
                        class="job-department--radio-values custom-radio"
                        v-if="item.total_job > 0"
                      >
                        <input
                          @change.prevent="filterJob('department')"
                          type="radio"
                          :id="'job-department--radio-values-' + index"
                          :value="item.id"
                          v-model="f_department"
                          name="job-department--radio-values"
                        />
                        <label :for="'job-department--radio-values-' + index"
                          >{{ item.name }} ({{ item.total_job }})</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="filter-block--child">
                <div class="toggleable-child-slots">
                  <h6
                    class="label m-b-0 toggle-thumb"
                    :class="{ 'thumb-visible': showThumb3 }"
                    @click="showThumb3 = !showThumb3"
                  >
                    JOB SHIFT
                  </h6>
                  <div class="inner-wrapper" v-show="showThumb3">
                    <div class="job-shift">
                      <div class="job-shift--radio-values custom-radio">
                        <input
                          @change.prevent="filterJob('job_shift')"
                          type="radio"
                          id="job-shift--radio-values-all"
                          value=""
                          v-model="f_job_shift"
                          name="job-shift--radio-values"
                          checked
                        />
                        <label for="job-shift--radio-values-all">All</label>
                      </div>
                      <div
                        v-for="(item, index) in jobShifts"
                        :key="index"
                        class="job-shift--radio-values custom-radio"
                        v-if="item.total_job > 0"
                      >
                        <input
                          @change.prevent="filterJob('job_shift')"
                          type="radio"
                          :id="'job-shift--radio-values-' + index"
                          :value="item.id"
                          v-model="f_job_shift"
                          name="job-shift--radio-values"
                        />
                        <label :for="'job-shift--radio-values-' + index"
                          >{{ item.name }} ({{ item.total_job }})</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="filter-block--child">
                <div class="toggleable-child-slots">
                  <h6
                    class="label m-b-0 toggle-thumb"
                    :class="{ 'thumb-visible': showThumb4 }"
                    @click="showThumb4 = !showThumb4"
                  >
                    LOCATION
                  </h6>
                  <div class="inner-wrapper" v-show="showThumb4">
                    <div class="location">
                      <div class="campus--radio-values custom-radio">
                        <input
                          @change.prevent="filterJob('campus')"
                          type="radio"
                          id="campus--radio-values-all"
                          value
                          v-model="f_location"
                          name="campus--radio-values"
                          checked
                        />
                        <label for="campus--radio-values-all">All</label>
                      </div>
                      <div
                        v-for="(item, index) in campusList"
                        :key="index"
                        class="campus--radio-values custom-radio"
                        v-if="item.total_job > 0"
                      >
                        <input
                          @change.prevent="filterJob('campus')"
                          type="radio"
                          :id="'campus--radio-values-' + index"
                          :value="item.id"
                          v-model="f_location"
                          name="campus--radio-values"
                        />
                        <label :for="'campus--radio-values-' + index"
                          >{{ item.name }} ({{ item.total_job }})</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--              <a href="#" @click.prevent="filterJob" class="primary-btn btn-mid mt&#45;&#45;5">APPLY FILTER</a>-->
            </div>
          </div>

          <div class="col-lg-7">
            <div class="search-results">
              <div class="d-flex filter-btn-wrapper">
                <button
                  class="btn-link filter-job-btn mr-auto"
                  @click="toggleSidebarFilter()"
                >
                  <i class="far fa-filter"></i>Filter Job
                </button>
                <h2 class="h5" v-if="total_results > 1">
                  {{ total_results }} Jobs Found
                </h2>
                <h2 class="h5" v-else>{{ total_results }} Job Found</h2>
              </div>

              <div class="search-result-info-bar d-flex align-items-center">
                <div class="total-displayed mr-auto" v-if="pagination.to > 1">
                  Displayed Here: {{ pagination.from }} -
                  {{ pagination.to }} Jobs
                </div>
                <div
                  class="total-displayed mr-auto"
                  v-else-if="pagination.to == 1"
                >
                  Displayed Here: {{ pagination.from }} -
                  {{ pagination.to }} Job
                </div>
                <div
                  class="total-displayed mr-auto"
                  v-else="pagination.to == 1"
                >
                  No Job Displayed
                </div>
                <div class="result-filters">
                  <div class="select-wrapper result-filters--select">
                    <label for="filter-by-timeline" class="sr-only"
                      >Most Recent</label
                    >
                    <select
                      name="filter-by-timeline"
                      id="filter-by-timeline"
                      v-model="sortBy"
                      @change="onChangeSortBy"
                    >
                      <option
                        v-for="(item, index) in sorting_options"
                        :value="index"
                        :key="index"
                      >
                        {{ item }}
                      </option>
                    </select>
                  </div>
                  <div class="select-wrapper result-filters--select">
                    <label for="show-per-page" class="sr-only"
                      >10 Per Page</label
                    >
                    <select
                      v-model="perPage"
                      @change="onChangePerPage"
                      name="show-per-page"
                      id="show-per-page"
                    >
                      <option
                        v-for="(la, lk) in limit_array"
                        :value="lk"
                        :key="lk"
                      >
                        {{ la }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="search-result-list">
                <a
                  v-if="!loading"
                  :href="item.link"
                  class="search-result-item d-block"
                  v-for="(item, index) in jobsData"
                  :key="index"
                >
                  <h3 class="h5">{{ item.title }}</h3>
                  <p class="desc-of-job">{{ item.description }}</p>
                  <div class="job-post-meta-group">
                    <span class="job-post-meta">
                      <i class="far fa-box"></i>
                      <span>{{ item.department }}</span>
                    </span>
                    <span class="job-post-meta">
                      <i class="far fa-calendar-check"></i>
                      <span>{{ item.application_deadline }}</span>
                    </span>
                    <span class="job-post-meta">
                      <i class="far fa-map-marker-alt"></i>
                      <span>{{ item.location }}</span>
                    </span>
                  </div>
                </a>
                <a
                  href="javascript:void(0)"
                  v-if="job_data_empty && !loading"
                  class="search-result-item no-results-found d-block"
                >
                  <p class="desc-of-job">No Job Found.</p>
                </a>
                <!--                  v-else-if="!job_data_empty && total_results==0"-->
                <div v-if="loading">
                  <loader></loader>
                  <loader></loader>
                  <loader></loader>
                </div>
                <pagination
                  :page-count="pagination.last_page"
                  :click-handler="setPagination"
                  :container-class="'pagination m-b-0'"
                  :page-class="'page-item'"
                  ref="pagination"
                ></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    jobTypeData: { type: Array, default: [] },
    departmentData: { type: Array, default: [] },
    shiftingData: { type: Array, default: [] },
    campusListData: { type: Array, default: [] },
    limit: { type: Number, default: 10 },
    limit_array: { type: Object, default: {} },
    sorting_options: { type: Object, default: {} },
  },
  data() {
    return {
      loading: false,
      job_type_toggle: false,
      deparment_toggle: false,
      location_toggle: false,
      departments: [],
      jobTypes: [],
      jobShifts: [],
      campusList: [],
      fetchUrl: "/api/jobs/list",
      perPage: 10,
      pagination: { to: 1, from: 1, current_page: 1, last_page: 1 },
      awaitingSearch: false,
      perPage: 10,
      sortBy: "recent",
      extra_params: {},
      jobsData: {},
      total_results: 0,
      job_data_empty: false,

      search: "",
      s_location: "",
      s_department: "",

      f_job_type: "",
      f_job_shift: "",
      f_department: "",
      f_sub_department: "",
      f_location: "",

      showThumb1: true,
      showThumb2: true,
      showThumb3: true,
      showThumb4: true,
      jobPosts: {},
      keywords: {},
      scrolled: 0,
      showSidebarFilter: false,
      load_filter_counter: false,
    };
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
    return this.fetchData();
  },
  computed: {
    stickySidebar() {
      return this.scrolled > 360;
    },
  },

  methods: {
    handleScroll() {
      this.scrolled = window.scrollY;
    },
    toggleSidebarFilter() {
      this.showSidebarFilter = !this.showSidebarFilter;
    },
    fetchData: function () {
      var params = {
        page: this.pagination.current_page,
        sortBy: this.sortBy,
        per_page: this.perPage,
      };

      if (this.load_filter_counter) {
        this.extra_params.load_counter = 1;
      } else {
        this.extra_params.load_counter = 0;
      }

      if (this.extra_params) {
        params = Object.assign({}, this.extra_params, params);
      }

      var _this = this;
      _this.loading = true;
      axios
        .get(this.fetchUrl, {
          params: params,
        })
        .then(({ data }) => {
          this.pagination = data.meta;
          
          this.jobsData = data.data;
          if (this.load_filter_counter) {
            // this.jobTypes = data.job_types;
            this.jobShifts = data.shiftings;
            this.departments = data.departments;
            this.campusList = data.campus;
          }

          this.total_results = data.meta.total;
          if (this.total_results) {
            this.job_data_empty = false;
          } else {
            this.job_data_empty = true;
          }
        })
        .catch((error) => this.$throwSwalError(error))
        .then(function () {
          _this.loading = false;
        });
    },
    toggleFilter(e) {
      e.target.classList.toggle("filter-opened");
      e.target.nextElementSibling.classList.toggle("filter-opened");
    },
    searchNow: function () {
      this.keywords = {};
      this.extra_params = {};
      this.load_filter_counter = true;
      this.clearFilter();

      if (this.search) {
        this.keywords.q = this.search;
      } else {
        delete this.keywords.q;
      }

      if (_.size(this.keywords)) {
        this.extra_params = this.keywords;
      }
      this.fetchData();
      this.resetPagiantion();
    },
    filterJob: function (clickFilter) {
      this.extra_params = {};
      this.load_filter_counter = true;

      if (clickFilter) {
        this.keywords.filter = clickFilter;
      } else {
        delete this.keywords.filter;
      }

      if (clickFilter == "job_type") {
        this.f_department = "";
        this.f_job_shift = "";
        this.f_location = "";
      }

      if (clickFilter == "department") {
        this.f_job_shift = "";
        this.f_location = "";
      }

      if (clickFilter == "job_shift") {
        this.f_location = "";
      }

      if (this.f_department) {
        this.keywords.department = this.f_department;
      } else {
        delete this.keywords.department;
      }

      if (this.f_job_type) {
        this.keywords.job_type = this.f_job_type;
      } else {
        delete this.keywords.job_type;
      }

      if (this.f_job_shift) {
        this.keywords.job_shift = this.f_job_shift;
      } else {
        delete this.keywords.job_shift;
      }

      if (this.f_location) {
        this.keywords.location = this.f_location;
      } else {
        delete this.keywords.location;
      }

      if (_.size(this.keywords)) {
        this.extra_params = this.keywords;
      }
      this.fetchData();
      this.resetPagiantion();
    },
    resetPagiantion: function () {
      this.pagination.current_page = 0;
      this.$refs.pagination.handlePageSelected(1);
    },
    onChangeSortBy: function () {
      this.fetchData();
    },
    onChangePerPage: function () {
      this.resetPagiantion();
      this.fetchData();
    },
    setPagination: function (page) {
      this.pagination.current_page = page;
      this.fetchData();
    },
    hideSidebarFilter(e) {
      const _el = document.querySelector(".sidebar-job-filter"),
        _filterBtn = document.querySelector(".filter-job-btn");
      !_el.contains(e.target) && !_filterBtn.contains(e.target)
        ? (this.showSidebarFilter = false)
        : false;
    },
    clearSearchBox: function () {
      this.search = "";
      this.clearFilter();
      this.searchNow();
    },
    clearFilter: function () {
      this.f_job_type = "";
      this.f_department = "";
      this.f_sub_department = "";
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    document.addEventListener("click", this.hideSidebarFilter);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    document.removeEventListener("click", this.hideSidebarFilter);
  },
  watch: {
    showSidebarFilter: {
      handler(vars) {
        vars === true
          ? document.getElementById("app").classList.add("sidebar-filter-open")
          : document
              .getElementById("app")
              .classList.remove("sidebar-filter-open");
      },
    },
    departmentData: {
      handler: function (val) {
        this.departments = val;
      },
      immediate: true,
    },
    jobTypeData: {
      handler: function (val) {
        this.jobTypes = val;
      },
      immediate: true,
    },
    shiftingData: {
      handler: function (val) {
        this.jobShifts = val;
      },
      immediate: true,
    },
    campusListData: {
      handler: function (val) {
        this.campusList = val;
      },
      immediate: true,
    },
  },

  components: {
    pagination: require("../../components/pagination").default,
    loader: require("./JobSearchLoader").default,
  },
};
</script>

<style lang="scss">
.result-filters--select {
  select {
    border: none;
    padding: 0 1rem 0 0;
    &:hover {
      color: var(--action-color);
    }
  }
  &::after {
    right: -0.5rem;
    line-height: 2.2rem;
  }
}
.job-search-form {
  .primary-btn {
    line-height: 1.5rem;
  }
}
.sidebar-filter-open {
  height: 100vh;
  overflow: hidden;
  position: relative;
  &::after {
    content: " ";
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
  }
}
</style>

<style lang="scss" scoped>
.toggle-thumb {
  position: relative;
  cursor: pointer;
  &::before,
  &::after {
    content: "\f068";
    position: absolute;
    right: 0;
    top: 0;
    opacity: 0;
    visibility: hidden;
    font-family: var(--font-awesome);
    font-size: 1.2rem;
    transition: all 0.2s;
  }

  &::after {
    content: "\f067";
    opacity: 1;
    visibility: visible;
  }
}
.thumb-visible {
  &::before {
    top: 0;
    opacity: 1;
    visibility: visible;
  }
  &::after {
    opacity: 0;
    visibility: hidden;
  }
}
.toggleable-child-slots {
  h6 {
    font-size: 1.5rem;
    font-weight: 400;
    color: var(--typo-para);
    border-bottom: 0.1rem solid var(--border-color);
    padding-bottom: 1rem;
    margin-bottom: 2rem;
  }
}
.search-bar {
  background-color: #fafafa;
  padding: 2.5rem 3rem;
  border-radius: var(--radius);
}

.input-wrapper {
  flex: 0 0 100%;
  max-width: 22rem;
  margin-bottom: 0;
  @media (min-width: 992px) {
    input,
    select {
      border-left: 0;
    }
  }
  @media (max-width: 1199px) {
    max-width: 19rem;
    margin-bottom: 1rem;
  }
  @media (max-width: 991px) {
    max-width: 100%;
  }
}
.select-wrapper.location-wrapper {
  i {
    left: 2rem;
    line-height: 4.5rem;
  }
  select {
    padding-left: 4.2rem;
  }
}
.search-input {
  flex: 0 0 100%;
  max-width: 80.4rem;
  input {
    border-left: 2px solid var(--input-border-color);
  }
  @media (max-width: 1399px) {
    max-width: 59.4rem;
  }
  @media (max-width: 991px) {
    max-width: 50.4rem;
  }
}
.job-search-form {
  .btn-wrapper {
    margin-left: 1rem;
  }

  @media (max-width: 767px) {
    .btn-wrapper {
      width: 100%;
      margin-left: 0;
    }
  }
}
.search-jobs {
  padding: 6rem 0 3.5rem;
  h1 {
    margin-bottom: 1.5rem;
    @media (max-width: 767px) {
      font-size: 1.7rem;
      margin-bottom: 0.5rem;
    }
  }
  p {
    margin-bottom: 2rem;
    @media (max-width: 767px) {
      font-size: 1.5rem;
    }
  }
}
.search-header-wrapper {
  p {
    margin-bottom: 30px;
  }
}

.filter-block,
.search-results {
  margin-top: 4rem;
}
.search-results {
  h2 {
    margin-top: 0;
  }
}

.filter-block--child {
  margin-bottom: 2.5rem;
  input,
  select {
    font-size: 1.4rem;
    line-height: 2rem;
    padding: 0.8rem 2rem;
  }
  .select-wrapper::after {
    font-size: 1.4rem;
    line-height: 4rem;
  }
  .btn-txt {
    font-size: 1.4rem;
    line-height: 2.2rem;
  }
}
.custom-radio,
.custom-checkbox {
  margin-bottom: 0.5rem;
}
input[type="checkbox"] ~ label,
input[type="radio"] ~ label {
  font-size: 1.4rem;
  color: var(--typo-para);
}
.search-results {
  padding-left: 1rem;
  @media (max-width: 991px) {
    padding-left: 0;
  }
}
.search-result-info-bar * {
  font-size: 1.4rem;
  line-height: 2.2rem;
  color: var(--typo-light);
}
.result-filters {
  display: flex;
  .select-wrapper {
    margin-left: 3rem;
    margin-right: 0.5rem;
  }
}
.search-result-list {
  margin-top: 2rem;
}

.search-result-item {
  padding: 3rem 3rem 2.5rem;
  margin-bottom: 2rem;
  border: 0.1rem solid var(--border-color);
  border-radius: var(--radius);
  transition: all 0.5s;
  h3 {
    color: var(--typo-title);
  }
  &:hover {
    color: inherit;
    border-color: var(--primary-color);
    text-decoration: none;
  }
}
.job-post-meta {
  display: inline-block;
  font-size: 1.4rem;
  line-height: 2.2rem;
  font-weight: 500;
  margin-right: 2rem;
  margin-bottom: 0.5rem;
  span {
    color: var(--typo-para);
  }
  i {
    margin-right: 0.4rem;
  }
}

.sub-departments-radio-values {
  margin-left: 20px;
}
option,
.result-filters option {
  color: var(--typo-para);
}

@media (max-width: 767px) {
  .total-displayed {
    width: 100%;
  }

  .filter-btn-wrapper {
    margin-bottom: 1rem;
  }
}

.filter-block .filter-block--child:last-child {
  margin-bottom: 0;
}
.filter-block::-webkit-scrollbar,
.sidebar-job-filter .filter-block::-webkit-scrollbar {
  width: 5px;
}

.filter-block::-webkit-scrollbar-track,
.sidebar-job-filter .filter-block::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
}

.filter-block::-webkit-scrollbar-thumb,
.sidebar-job-filter .filter-block::-webkit-scrollbar-thumb {
  background-color: #dedede;
  outline: none;
}
.btn-link {
  margin: 0;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.department--radio-values {
  position: relative;
}
.filter-toggler {
  position: absolute;
  top: 0.2rem;
  right: 0;
  cursor: pointer;
  &::before,
  &::after {
    content: "\f068";
    position: absolute;
    right: 0;
    top: 2rem;
    opacity: 0;
    visibility: hidden;
    font-family: var(--font-awesome);
    font-size: 1.2rem;
    transition: all 0.2s;
  }

  &::after {
    content: "\f067";
    top: 0;
    opacity: 1;
    visibility: visible;
  }
  &.filter-opened {
    &::before {
      top: 0;
      opacity: 1;
      visibility: visible;
    }
    &::after {
      top: -2rem;
      opacity: 0;
      visibility: hidden;
    }
  }
}
.sub-menuitem-wrapper {
  display: none;
  padding-left: 1.8rem;

  &.filter-opened {
    display: block;
  }
}
.filter-job-btn {
  font-size: 1.8rem;
  font-weight: 500;
  margin-bottom: 10px;
  display: none;
  &:hover {
    text-decoration: none;
  }

  i {
    font-size: 1.4rem;
    margin-right: 5px;
  }
}
@media (max-width: 991px) {
  .filter-job-btn {
    display: block;
  }
  .sidebar-job-filter {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 330px;
    height: 100%;
    background: rgba(28, 43, 60, 0.75);
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    z-index: 99999;
    padding: 0;
    transform: translateX(-100%);

    .filter-block {
      background: #fff;
      position: relative;
      height: 100%;
      text-align: left;
      padding-top: 85px;
      padding: 20px;
      margin-top: 0;
    }
    &.sidebar-job-filter-active {
      transform: translateX(0%);
    }
  }
}
.filter-closebtn {
  position: absolute;
  top: 1rem;
  left: 1.5rem;
  padding: 5px;
  z-index: 99999;
}

.clear-search {
  cursor: pointer;
  pointer-events: all;
  transition: 0.3s;
  &:hover {
    color: var(--action-color);
  }
}
</style>
